<template>
  <div v-if="products.length > 4" class="carousel-container">
    <h2 class="page-title">
      {{ title }}
    </h2>
    <Carousel
      alt-prev-text="Previous"
      alt-next-text="Next"
      lazy-load="ondemand"
      :overlay-arrows="false"
      :pause-on-hover="true"
      :arrows="true"
      :swipe="false"
      :slides-to-show="5"
      :slides-to-scroll="5"
      :responsive="responsive"
      :infinite="false"
      :adaptive-height="false"
    >
      <ImpressionTrackingContainer
        v-for="(product, index) in products"
        :key="product.id"
        :threshold="[0.5]"
        root-margin="-15% 0% 0%"
        @track-impression="
          $emit('track-product-impression', product, index + 1)
        "
      >
        <ProductCardContainer
          :product="product"
          :product-index="index"
          @click.native="$emit('track-product-click', product, index + 1)"
        />
      </ImpressionTrackingContainer>
    </Carousel>
  </div>
</template>

<script>
import Carousel from '@sephora-asia/core-carousel/Carousel.vue'
import ProductCardContainer from './ProductCardContainer.vue'

export default {
  name: 'HomePageCarousel',

  components: {
    Carousel,
    ProductCardContainer
  },

  props: {
    title: {
      type: String,
      required: true
    },
    products: {
      type: Array,
      required: true
    }
  },

  computed: {
    responsive() {
      return [
        {
          breakpoint: 1023,
          settings: {
            arrows: true,
            swipe: true,
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 767,
          settings: {
            arrows: false,
            swipe: true,
            slidesToShow: 2.5,
            slidesToScroll: 2
          }
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
.carousel-container {
  margin-top: 4px;
  margin-bottom: 24px;
}
</style>
